import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, Text } from '@blueprint/ui';

const Container = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        display: none;
        ${mq.large} {
            display: flex;
            flex-direction: row;
            margin: 0 calc(-${spacing['24px']} / 2);
        }
    `
);

const StyledCallout = styled('div')(
    ({ theme: { colors, borderRadius, spacing } }) => css`
        position: relative;
        padding: ${spacing['24px']} ${spacing['24px']} ${spacing['24px']} 5.5em;
        border: 1px solid ${colors['graphic-divider-light']};
        border-radius: ${borderRadius['4px']};
        width: 50%;
        margin: 0 calc(${spacing['24px']} / 2);
        ${Text} {
            margin-bottom: ${spacing['8px']};
        }
        ${Button} {
            margin-top: ${spacing['8px']};
        }
    `
);

const CircleIcon = styled('span')(
    ({ theme: { colors, spacing } }) => css`
        background: ${colors['graphic-background-accent-light']};
        width: ${spacing['48px']};
        height: ${spacing['48px']};
        border-radius: 50%;
        color: ${colors['primary-brand']};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: ${spacing['24px']};
        top: ${spacing['24px']};
    `
);

export { StyledCallout, CircleIcon, Container };
